import React from 'react'
import Header from '../../../Components/Header'
import Footer from '../../../Components/Footer'

const PrivacyPolicy = () => {
    return (
        <>
            <Header />

            <p>Privacy Policy page</p>
            <Footer />
        </>
    )
}

export default PrivacyPolicy
